import React, { useState } from "react";
import { setTimePreparationAPI } from "../../Api/SupplierServices";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import Button from "../Button/Button";
import Input from "../Input/Input";
import Style from "./PreparationTime.module.css";
const PreparationTime = ({ orderID, closemodal }) => {
  const [Minuts, setMinuts] = useState("");
  const [hour, setHour] = useState("");

  const setTimeHandler = () => {
    if (hour === "" && Minuts === "") {
      // if(Minuts===''){
      errorToast("لطفا زمان را مشحص کنید");
      // }
    } else if (Minuts > 60) {
      errorToast("دقیقه را درست وارد کنید!");
    } else {
      let info = {
        id: orderID,
        prepare_remaining_time:
          hour === ""
            ? parseInt(Minuts)
            : parseInt(hour) * 3600 + parseInt(Minuts),
      };
      setTimePreparationAPI(info, (succ) => {
        if (succ.status === 1) {
          succToast(succ.message);

          setTimeout(() => {
            closemodal();
            window.location.reload();
          }, 500);
        } else {
          errorToast(succ.message);
        }
      });
    }
  };
  return (
    <section className={Style.sectionHolder}>
      <p>مدت زمان آماده سازی را به دقیقه وارد کنید</p>
      <div>
        <Input
          placeholder="دقیقه"
          value={Minuts}
          onChange={(e) => setMinuts(e.target.value)}
          type={"number"}
        />
      </div>
      <Button
        Value={"ثبت"}
        ClassBtn={"confirmBtn"}
        ClickHandler={setTimeHandler}
      />
    </section>
  );
};

export default PreparationTime;
